import React from "react";
import ReactPaginate from "react-paginate";

interface PaginationControlsProps {
  currentPage: number;
  totalQuestions: number;
  questionsPerPage: number;
  onPageChange: (selectedItem: { selected: number }) => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
  currentPage,
  totalQuestions,
  questionsPerPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalQuestions / questionsPerPage);

  return (
    <div className="pagination-controls mt-5 mb-2 w-full flex justify-center items-center flex-wrap">
      <ReactPaginate
        previousLabel={
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.4306 5.66965C10.7975 5.35516 11.3499 5.39765 11.6644 5.76456L18.6644 13.9312C18.9452 14.2589 18.9452 14.7424 18.6644 15.0701L11.6644 23.2368C11.3499 23.6037 10.7975 23.6462 10.4306 23.3317C10.0637 23.0172 10.0212 22.4648 10.3357 22.0979L16.8476 14.5007L10.3357 6.90344C10.0212 6.53653 10.0637 5.98415 10.4306 5.66965Z"
              fill="white"
            />
          </svg>
        }
        nextLabel={
          <svg
            width="29"
            height="29"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.5694 5.66965C18.2025 5.35516 17.6501 5.39765 17.3356 5.76456L10.3356 13.9312C10.0548 14.2589 10.0548 14.7424 10.3356 15.0701L17.3356 23.2368C17.6501 23.6037 18.2025 23.6462 18.5694 23.3317C18.9363 23.0172 18.9788 22.4648 18.6643 22.0979L12.1524 14.5007L18.6643 6.90344C18.9788 6.53653 18.9363 5.98415 18.5694 5.66965Z"
              fill="white"
            />
          </svg>
        }
        previousClassName={"px-4 py-2 rounded"}
        activeLinkClassName="!bg-primaryColor !text-black"
        pageLinkClassName="px-4 py-2 rounded text-white"
        nextClassName={"px-4 py-2 rounded"}
        breakClassName={"px-4 py-2 rounded"}
        previousLinkClassName={"text-white"}
        nextLinkClassName={"text-white"}
        breakLinkClassName={"text-white"}
        className="flex items-center justify-center gap-4 flex-wrap"
        breakLabel="..."
        pageCount={totalPages}
        marginPagesDisplayed={2}
        pageRangeDisplayed={2}
        onPageChange={onPageChange}
        forcePage={currentPage - 1}
      />
    </div>
  );
};

export default PaginationControls;
